export class StepColoring {
  public VALIDATION = 'tx-primary';
  public MONITORING = 'tx-light-background';
  public FINISHED = 'tx-primary-dark';
  public DISPATCH = 'tx-danger';
  public CONFIGURATION = 'tx-info';
  public SCHEDULING = 'tx-accent';
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/step-coloring.ts